import { render, staticRenderFns } from "./dynamicMarkupLists.vue?vue&type=template&id=1f983067&scoped=true&"
import script from "./dynamicMarkupLists.vue?vue&type=script&lang=js&"
export * from "./dynamicMarkupLists.vue?vue&type=script&lang=js&"
import style0 from "./dynamicMarkupLists.vue?vue&type=style&index=0&id=1f983067&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f983067",
  null
  
)

export default component.exports